import { HRM2120_R01DetailDto } from './Dto_HRM2120_R01';

/** 종료일을 비워 두었을 때 서버에 저장하는 계속 적용 날짜이다. */
export const END_DT_OPEN = '9999-12-31';

/** 열린 종료일을 화면에서 빈칸으로 보인다. */
export const formatHRM2120_R01EndDt = (value: string | null | undefined): string =>
    !value || value === END_DT_OPEN ? '' : value;

/** 신규 이력의 시작일인 이번 달 첫날을 현지 날짜로 반환한다. */
export const getHRM2120_R01FirstDateOfMonth = (): string => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${year}-${month}-01`;
};

/** 배정의 필수값, 시작일 중복과 기간 겹침을 검사하고 첫 오류 문장을 반환한다. */
export const validateHRM2120_R01ShiftList = (
    empNm: string,
    list: HRM2120_R01DetailDto[],
    workShiftCodes: string[],
): string | null => {
    const starts = new Set<string>();
    for (const row of list) {
        if (!row.startDt) return `${empNm}: 적용시작일을 입력하세요.`;
        if (row.assignType !== 'FIX' && row.assignType !== 'ROT') {
            return `${empNm}: 배정 방식을 고르세요.`;
        }
        if (row.assignType === 'FIX' && (!row.shiftCd || !workShiftCodes.includes(row.shiftCd))) {
            return `${empNm}: 고정 근무조를 고르세요.`;
        }
        if (row.assignType === 'ROT' && row.rotGroup !== 'A' && row.rotGroup !== 'B') {
            return `${empNm}: 교대조(A/B)를 고르세요.`;
        }
        if ((row.endDt || END_DT_OPEN) < row.startDt) return `${empNm}: 종료일이 시작일보다 빠릅니다.`;
        if (starts.has(row.startDt)) return `${empNm}: 같은 적용시작일의 배정이 이미 있습니다.`;
        if (row.remark.length > 1000) return `${empNm}: 비고는 1000자 이하여야 합니다.`;
        starts.add(row.startDt);
    }

    const sorted = [...list].sort((a, b) => a.startDt.localeCompare(b.startDt));
    for (let index = 1; index < sorted.length; index += 1) {
        if (sorted[index].startDt <= (sorted[index - 1].endDt || END_DT_OPEN)) {
            return `${empNm}: 배정 기간이 겹칩니다 — 이전 행의 종료일을 먼저 닫으세요.`;
        }
    }
    return null;
};
